import React, {useState} from 'react'
import {Button, Modal} from "antd";
import {deleteCustomer} from "../../services/serviceCustomer";

const CustomerDelete = ({customer, updater}) => {

    const [deleteModal, setDeleteModal] = useState(false)

    const handleDeleteClick = (decision) => {
        if (decision){
            deleteCustomer(customer.id)
                .then(() => {
                    setDeleteModal(!deleteModal)
                    updater()
                })
        }else{
            setDeleteModal(!deleteModal)
        }
    }

    return(
        <React.Fragment>
            <Button type={'link'} danger onClick={()=>setDeleteModal(!deleteModal)}>Sil</Button>

            <Modal
                open={deleteModal}
                closable={false}
                title={'Silmek istediğinizden emin misiniz ?'}
                footer={[
                    <Button type={'primary'} danger key={'submitButton'} onClick={()=> handleDeleteClick(true)}>Onayla</Button>,
                    <Button key={'cancelButton'} onClick={() => handleDeleteClick(false)}>Vazgeç</Button>
                ]}
            >

            </Modal>

        </React.Fragment>
    )
}
export default CustomerDelete